







































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import firebase from "firebase";
import UserModel, { UserDb } from "@/models/User";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import moment, { version } from "moment";
import { mask } from "vue-the-mask";
import { ParteChaves } from "../models/Processo";
import _debug from "debug";

const debug = _debug("Mediacao:components:UsuarioFormulario.vue");

const userModule = getModule(UserModule, store);

export interface DadosAlteracaoUsuario {
    parte: ParteChaves;
    usuario: UserDb;
    original: UserDb;
}

@Component({
    components: {},
    directives: { mask },
})
export default class UsuarioFormulario extends Vue {
    @Prop() public usuarioOriginal!: UserDb;
    @Prop() public parte!: ParteChaves;
    @Prop({ default: false }) public temBotaoRemover!: boolean;
    @Prop({ default: "É necessário preencher seus dados antes de continuar" }) public formMessage!: string;
    @Prop({ default: false }) public souOMediador!: boolean;
    private usuarioDados: UserDb = Object.assign({}, this.usuarioOriginal);
    private dataNascimentoFormatada = "";
    private menuDataNascimento = false;
    private cellMask: string[] = ["(##) ####-####", "(##) #####-####"];
    private usuarioJaExiste = false;
    private usuarioPreenchendoSeusDados = false;
    private usuarioSelecionado: string | null = null;
    private usuarioSelecionadoDaBase = false;
    private formValid = false;
    private usuariosNaPlataforma: UserDb[] = [];
    private emailBusca = "";
    private isLoadingUsuariosPorEmail = false;

    private rules: any = {
        nome: [(v: string) => !!v || "O Nome completo é obrigatório!", (v: string) => (v && v.length <= 260) || "O Nome deve ter no máximo 260 caracteres!"],
        email: [
            (v: string) => !!v || "O email é obrigatório!",
            (v: string) =>
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(v) ||
                "Email inválido, por favor digite um email válido!",
        ],
        dataNascimento: [(v: string) => !!v || "A Data de Nascimento é obrigatória!"],
        cellPhone: [(v: string) => !!v || "O número do telefone celular é obrigatório!"],
        cpf: [(v: string) => !!v || "O número do CPF é obrigatório!"],
    };

    @Watch("menuDataNascimento", { immediate: true, deep: true })
    public onMenuDataNascimentoChanged(val: boolean, oldVal: boolean) {
        const picker = this.$refs.dataNascimentoPicker as any;
        if (val) {
            if (this.usuarioDados.dataNascimento && /\d{4,4}-\d{2,2}-\d{2,2}/.test(this.usuarioDados.dataNascimento)) {
                setTimeout(() => {
                    picker.activePicker = "DATE";
                });
            } else {
                setTimeout(() => {
                    picker.activePicker = "YEAR";
                });
            }
        }
    }
    @Watch("emailBusca")
    public onEmailBuscaChange(val: string, oldVal: string) {
        //console.log("onEmailBuscaChange", val, oldVal);
        if (!val && !oldVal) {
            return;
        }
        if (this.usuariosNaPlataforma.length > 0) {
            // Já carregou
            if (oldVal && oldVal.length > val.length && val.length === 0) {
                // apagou tudo, deleta a lista carregada
                this.usuariosNaPlataforma.splice(0);
            }
            return;
        }
        if (this.isLoadingUsuariosPorEmail) {
            return;
        }

        if (val.length > 3) {
            UserModel.fetchUsersByEmail(this.emailBusca.toLowerCase())
                .then(users => {
                    users.forEach(user => {
                        const userMail = Object.assign({ text: user.email + " - " + user.name, value: user.email }, user);
                        this.usuariosNaPlataforma.push(userMail);
                    });
                })
                .catch(err => {
                    console.error(err);
                })
                .finally(() => (this.isLoadingUsuariosPorEmail = false));
        }
    }

    private selecionouDaBase(event: any) {
        console.log("selecionou da base", event);
        if (event) {
            const userBase = event;
            this.usuarioDados.email = userBase.email;
            this.usuarioDados.name = userBase.name;
            this.usuarioDados.roles = userBase.roles;
            this.usuarioDados.photoURL = userBase.photoURL;
            this.usuarioDados.cellPhone = userBase.cellPhone;
            this.usuarioDados.cpf = userBase.cpf;
            this.usuarioDados.dataNascimento = userBase.dataNascimento;
            this.selecionouData();
            this.usuarioSelecionadoDaBase = true;
        } else {
            console.log("tem que limpar");
            this.usuarioSelecionadoDaBase = false;
            this.usuarioDados.email = "";
            this.usuarioDados.name = "";
            this.usuarioDados.roles = [];
            this.usuarioDados.photoURL = "";
            this.usuarioDados.cellPhone = "";
            this.usuarioDados.cpf = "";
            this.usuarioDados.dataNascimento = "";
            this.selecionouData();
        }
    }

    private showMenuDataNascimento() {
        debug("showMenu!");
        this.menuDataNascimento = true;
    }

    private created() {
        console.log("UsuarioFormulario.created");
        if (this.$route.query.modo === "proprio") {
            Object.assign(this.usuarioDados, userModule.getUser.userDb);
            this.usuarioPreenchendoSeusDados = true;
            this.selecionouData();
        } else {
            if (this.usuarioOriginal && this.usuarioOriginal.email && this.usuarioOriginal.email.length > 0) {
                this.usuarioJaExiste = true;
                this.selecionouData();
            }
        }
    }

    private selecionouData() {
        debug("Selecionou data!");
        this.menuDataNascimento = false;
        this.dataNascimentoFormatada = this.usuarioDados.dataNascimento ? moment(this.usuarioDados.dataNascimento).format("DD/MM/YYYY") : "";
    }

    private leDataFormatada(event: KeyboardEvent) {
        try {
            debug("leDataFormatada", this.dataNascimentoFormatada, event);
            if (!event) {
                this.$set(this.usuarioDados, "dataNascimento", "");
            } else {
                const data = moment(this.dataNascimentoFormatada, "DD/MM/YYYY", true);
                if (data.isValid()) {
                    this.$set(this.usuarioDados, "dataNascimento", data.format("YYYY-MM-DD"));
                    this.menuDataNascimento = false;
                }
            }
        } catch (e) {
            console.error("Erro lendo data formatada!", e);
        }
    }

    private async salvar() {
        debug("Salvando dados do usuário!", this.usuarioDados);
        const saved = await UserModel.setUserdb(this.usuarioDados);
        this.$emit("usuarioParteAlterado", {
            parte: this.parte,
            usuario: this.usuarioDados,
            original: this.usuarioOriginal,
        } as DadosAlteracaoUsuario);
    }

    private cancelar() {
        debug("Limpando dados do usuário!", this.usuarioDados);
        this.usuarioDados = Object.assign({}, this.usuarioOriginal);
        this.$emit("cancelarEdicaoUsuario", {
            parte: this.parte,
            usuario: this.usuarioDados,
            original: this.usuarioOriginal,
        } as DadosAlteracaoUsuario);
    }
    private removerParte() {
        this.$emit("removerParte", {
            parte: this.parte,
            usuario: this.usuarioDados,
            original: this.usuarioOriginal,
        } as DadosAlteracaoUsuario);
    }
}
